module.exports = __webpack_public_path__ + "img/kiribati.e0e59b15.svg";